import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { FloatLabel } from 'primeng/floatlabel';

import { GridAutocompleteComponent } from 'sc-common/shared/components/grid-autocomplete/grid-autocomplete.component';

@NgModule({
    imports: [AutoCompleteModule, CommonModule, FloatLabel],
    declarations: [GridAutocompleteComponent],
    exports: [GridAutocompleteComponent]
})
export class GridAutocompleteModule { }
